import React, { lazy } from 'react';

import { createBrowserRouter } from 'react-router-dom';

import UserAuthChecker from './HOC/auth';
import { UserDataProvider } from '../../App/Component/UserDataProvider';

const Admin = lazy(() => import('../../Admin'));
const ApprovalsContainer = lazy(
  () => import('../../Approvals/Component/ApprovalsComponent')
);
const AssigneeFlow = lazy(() => import('../../AssigneeFlow'));
const ClauseLibraryAdminComponent = lazy(
  () =>
    import('../../ClauseLibrary/Admin/Component/ClauseLibraryAdminComponent')
);
const DataDictionaryAdminContainer = lazy(
  () => import('../../DataDictionary/Admin')
);
const DataDictionaryCreateType = lazy(
  () => import('../../DataDictionary/Admin/Component/DataDictionaryCreateType')
);
const Designation = lazy(() => import('../../Designation'));
const DocumentLibraryComponent = lazy(
  () => import('../../DocumentLibrary/Component/DocumentLibraryComponent')
);
const DocumentView = lazy(
  () => import('../../DocumentView/Container/documentCon')
);
const DraftComponent = lazy(
  () => import('../../Draft/Component/DraftComponent')
);
const ViewDraft = lazy(() => import('../../Draft/Component/ViewDraft'));
const EmailAudit = lazy(() => import('../../EmailAudit/EmailAudit'));
const VerifyExternalUser = lazy(
  () => import('../../ExternalUserFlow/VerifyExternalUser')
);
const FilterComponent = lazy(
  () => import('../../Filter/Components/FilterComponent')
);
const Groups = lazy(() => import('../../Groups'));
const LocationManagement = lazy(() => import('../../LocationManagement'));
const PartyMaster = lazy(() => import('../../PartyMaster'));
const NegativeList = lazy(() => import('../../NegativeList'));
const ProductMaster = lazy(() => import('../../ProductMaster'));
const ProjectConfig = lazy(() => import('../../ProjectConfig/ProjectConfig'));
const ReminderComponent = lazy(
  () => import('../../Reminder/ReminderComponent')
);
const DraftLayout = lazy(
  () => import('../../RiverusUI/Components/Layouts/DraftLayout')
);
const Roles = lazy(() => import('../../Roles'));
const Root = lazy(() => import('../../Root'));
const Search = lazy(() => import('../../Search/Components/search'));
const Sessions = lazy(() => import('../../Sessions/Sessions'));
const Settings = lazy(() => import('../../Setting'));
const StampBank = lazy(() => import('../../StampBank'));
const TatConfig = lazy(() => import('../../Tat/Admin'));
const TerritoryMaster = lazy(() => import('../../TerritoryMaster'));
const AdminTemplate = lazy(() => import('../../Templates/Admin'));
const ViewTemplate = lazy(
  () => import('../../Templates/Admin/Component/ViewTemplate')
);
const UserManagement = lazy(() => import('../../UserManagement'));
const ReportsCorner = lazy(() => import('../../ReportsCorner'));

export const privateRouter = createBrowserRouter([
  {
    path: '*',
    Component: UserAuthChecker(Root),
    children: [
      {
        path: 'document/:page/:id/:requestid?',
        element: <DocumentView />,
      },
      {
        path: 'search/:query',
        element: <Search />,
      },
      {
        path: 'documentlibrary',
        element: <DocumentLibraryComponent />,
      },
      {
        path: 'documentlibrary/reports-corner',
        element: <ReportsCorner />,
      },
      {
        path: 'reminders',
        element: <ReminderComponent />,
      },
      {
        path: 'templates',
        element: <AdminTemplate />,
      },
      {
        path: 'admin/templates',
        element: <AdminTemplate />,
      },
      {
        path: 'admin/tat-config',
        element: <TatConfig />,
      },
      {
        path: 'template/:id/:page',
        element: <ViewTemplate />,
      },
      {
        path: 'admin/party-master',
        element: <PartyMaster />,
      },
      {
        path: 'admin/negative-list',
        element: <NegativeList />,
      },
      {
        path: 'admin/product-master',
        element: <ProductMaster />,
      },
      {
        path: 'admin/territory-master',
        element: <TerritoryMaster />,
      },
      {
        path: 'admin/project-config',
        element: <ProjectConfig />,
      },
      {
        path: 'admin/assignee-flow',
        element: <AssigneeFlow />,
      },
      {
        path: 'admin/stamp-bank',
        element: <StampBank />,
      },
      {
        path: 'admin/internal-users',
        element: <UserManagement />,
      },
      {
        path: 'admin/groups',
        element: <Groups />,
      },
      {
        path: 'admin/roles',
        element: <Roles />,
      },
      {
        path: 'admin/location',
        element: <LocationManagement />,
      },
      {
        path: 'admin/designation',
        element: <Designation />,
      },
      {
        path: 'draftingreview',
        element: <DraftComponent />,
      },
      {
        path: 'draftingreview/:id',
        element: <DraftComponent />,
      },
      {
        path: 'approvals',
        element: <ApprovalsContainer />,
      },
      {
        path: 'admin/data-dictionary/:id/',
        element: <DataDictionaryCreateType />,
      },
      {
        path: 'admin/data-dictionary',
        element: <DataDictionaryAdminContainer />,
      },
      {
        path: 'admin/clause-library-admin',
        element: <ClauseLibraryAdminComponent />,
      },
      {
        path: 'admin/settings',
        element: <Settings />,
      },
      {
        path: 'admin/sessions',
        element: <Sessions />,
      },
      {
        path: 'admin/email-audit',
        element: <EmailAudit />,
      },
      {
        path: 'admin',
        element: <Admin />,
      },
      {
        path: 'filter',
        element: <FilterComponent />,
      },
      {
        path: 'draft',
        element: <DraftLayout />,
        children: [{ path: ':version/:id?', element: <ViewDraft /> }],
      },
      {
        path: 'draftingreview/reports-corner',
        element: <ReportsCorner />,
      },
    ],
  },
]);

export const externalRouter = createBrowserRouter([
  {
    path: '*',
    children: [
      {
        path: 'draft/:version/:id',
        element: (
          <UserDataProvider>
            <VerifyExternalUser />
          </UserDataProvider>
        ),
      },
    ],
  },
]);
